<template>
	<el-form size="mini" ref="form" :model="form" label-width="100px" :inline="true" :show-message="false">
		<el-form-item label="序列号" style="display: block;width: 1000px !important;" class="detail_item">
			<el-input style="width: 776px !important;" readonly v-model="item.number"></el-input>
		</el-form-item>
		<el-form-item label="收件人" class="detail_item">
			<el-input v-model="form.addressee"></el-input>
		</el-form-item>
		<el-form-item label="收件人号码" class="detail_item">
			<el-input v-model="form.addresseephone"></el-input>
		</el-form-item>
		<el-form-item label="快递单号" class="detail_item">
			<el-input v-model="form.addresseecode"></el-input>
		</el-form-item>
		<el-form-item label="收件人地址" class="detail_item">
			<el-input style="width: 466px;" v-model="form.addresseeaddress"></el-input>
		</el-form-item>		
		<el-form-item label="邮寄状态" class="detail_item">
			<emun style="width: 185px;" v-model="form.addresseestatus" name="addresseestatus" :readonly="true" />
		</el-form-item>
		<el-form-item label="邮寄时间" class="detail_item">
			<el-input style="width: 185px;" v-model="form.addresseetime"></el-input>
		</el-form-item>				
<!-- 		<el-form-item style="width: 100%;margin-left: 100px;">
			<el-button :loading="loading" type="success" @click="sync">同步线上</el-button>
			<el-button type="primary" @click="onSubmit">保存</el-button>
		</el-form-item> -->
	</el-form>
</template>
<style scoped>
.detail_item{
	margin-bottom: 4px;
}
</style>
<script>
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	export default {
		props: {
			item: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				loading:false,
				form: {
					addressee: '',
					addresseephone: '',
					addresseeaddress: '',
					addresseecode: '',
					addresseestatus: '',
					addresseetime: '',
				},

			}
		},
		watch: {

		},
		computed: {

		},
		created() {
			for (let i in this.form) {
				this.form[i] = this.item[i]
			}
		},
		mounted() {

		},
		methods: {
			sync() {
				if (this.item.ordercode != '') {
					this.loading = true
					this.$api.searchInvoiceoutput(this.item.ordercode).then((res) => {
						if (res.data.length != 0) {
							this.getItemValue(res.data[0])
						} else {
							this.submitBuff = false
							this.$message.error('未查询到订单')
						}
						this.loading = false
					})
				} else {
					this.$message.error('请填写订单编号')
				}
			},
			getItemValue(data) {
				this.form.addresseeaddress += data.province + data.city + data.district
				this.form.addresseecode = data.express_code
				this.form.addresseestatus = this.$store.state.olnStatusMap[data.oln_status]
				if (data.sensitive_address) {
					this.form.addressee = data.sensitive_address.receiver_name_mask
					this.form.addresseephone = data.sensitive_address.receiver_phone_mask ? data
						.sensitive_address.receiver_phone_mask : data.sensitive_address
						.receiver_mobile_mask
				}
			},	
			onSubmit() {
				this.$api.updateInvoiceoutput(this.item.id, this.form).then(() => {
					this.$message({
						message: '操作成功',
						type: 'success'
					})

				})
			}					
		},
		components: {
			emun
		}
	}
</script>
